const paramsAreArrayKeys = new Set(['amenities']);

const parseSearchLink = (url) => {
	const urlParams = new URLSearchParams(url);
	const params = {};

	// Convert URLSearchParams to an array of entries and iterate
	Array.from(urlParams.entries()).forEach(([rawKey, value]) => {
		// Normalize bracket notation keys (e.g., amenities[] -> amenities)
		const key = rawKey.endsWith('[]') ? rawKey.slice(0, -2) : rawKey;

		// Currently only amenities operates as a [], extensible to other fields
		if (paramsAreArrayKeys.has(key)) {
			// If the key is an array-type, add the value to an array
			if (!params[key]) {
				params[key] = [];
			}
			params[key].push(value);
		} else {
			// For other keys, directly assign the value (last one wins if duplicated)
			params[key] = value;
		}
	});

	return params;
};

export default parseSearchLink;
